import { gql } from 'graphql-request'

export const USUARIOS_STARTS_WITH = gql`
  query usuariosStartsWith($nome: String!) {
    usuariosByNomeOrEmailStartingWith(nome: $nome) {
      id
      nome
      email
      active
    }
  }
`
